import { cn } from '@/lib/utils';

type Provider = 'google' | 'discord';

const labels: Record<Provider, string> = {
	google: 'Continue with Google',
	discord: 'Continue with Discord',
};

function GoogleIcon() {
	return (
		<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
			<path
				fill="#4285F4"
				d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
			/>
			<path
				fill="#34A853"
				d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.15-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
			/>
			<path
				fill="#FBBC05"
				d="M5.85 14.1a7.02 7.02 0 010-4.2V7.06H2.18a11 11 0 000 9.88l3.67-2.84z"
			/>
			<path
				fill="#EA4335"
				d="M12 5.38c1.62 0 3.07.56 4.21 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.67 2.84C6.71 7.31 9.14 5.38 12 5.38z"
			/>
		</svg>
	);
}

function DiscordIcon() {
	return (
		<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
			<path
				fill="#5865F2"
				d="M20.3 4.37A19.8 19.8 0 0015.3 3l-.22.4a18.3 18.3 0 00-6.15 0L8.7 3a19.8 19.8 0 00-5 1.37C.6 9.05-.25 13.6.16 18.08A19.9 19.9 0 006.15 21l1.2-1.64a12.8 12.8 0 01-1.9-.93l.47-.35a14.2 14.2 0 0012.16 0l.47.35c-.6.36-1.24.67-1.9.94L17.85 21a19.9 19.9 0 005.99-2.92c.48-5.2-.81-9.7-3.54-13.71zM8.52 15.3c-1.18 0-2.15-1.07-2.15-2.4s.95-2.4 2.15-2.4c1.2 0 2.17 1.08 2.15 2.4 0 1.33-.95 2.4-2.15 2.4zm6.96 0c-1.18 0-2.15-1.07-2.15-2.4s.95-2.4 2.15-2.4c1.2 0 2.17 1.08 2.15 2.4 0 1.33-.95 2.4-2.15 2.4z"
			/>
		</svg>
	);
}

interface OAuthButtonProps {
	provider: Provider;
	onClick?: () => void;
	disabled?: boolean;
	className?: string;
}

export function OAuthButton({ provider, onClick, disabled, className }: OAuthButtonProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={cn(
				'inline-flex w-full items-center justify-center gap-2 rounded-lg border border-loomlite-border-strong bg-loomlite-ink px-3.5 py-2.5 text-sm font-medium text-loomlite-text transition-colors hover:border-slate-400/35 hover:bg-[#141726] disabled:opacity-50',
				className,
			)}
		>
			{provider === 'google' ? <GoogleIcon /> : <DiscordIcon />}
			{labels[provider]}
		</button>
	);
}
